module.exports = __webpack_public_path__ + "static/media/img-124.068220b9.jpg";